import $ = require("jquery");
import ko = require("knockout");
require("knockout.validation");
export module KnockoutValidationOptions {
    export function register(options?: KnockoutValidationConfiguration) {
        var appDefaults = {
            registerExtenders: true,
            messagesOnModified: true,
            insertMessages: true,
            parseInputAttributes: true,
            messageTemplate: null,
            errorElementClass: "has-error",
            errorMessageClass: "help-block",
            decorateInputElement: true,
            grouping: {
                deep: true,
                observable: true,
                live: true
            }
        };

        if (options)
            $.extend(appDefaults, options);

        ko.validation.init(appDefaults);
    }
}